import { Navigate, type RouteObject } from 'react-router-dom';
import AssetsPage from '../pages/AssetsPage';
import LocationPage from './pages/LocationPage';

const routes: RouteObject[] = [
  {
    index: true,
    element: <AssetsPage tab="locations" />,
  },
  {
    path: ':id',
    children: [
      {
        index: true,
        element: <Navigate to="details" replace />,
      },
      {
        path: ':tab',
        element: <LocationPage />,
      },
    ],
  },
];

export default routes;
